import DisclosureGuidelineModal from '@Components/Bases/DisclosureGuidelineModal';
import InfoPopUpIcon from '@Components/Icons/InfoPopUpIcon';
import { useDisclosure } from '@hooks/useDisclosure';
import { Box, Button, Typography } from '@mui/material';

const DisclosureGuidelinesIndustryMarketPolicies = () => {
  const [opened, { open, close }] = useDisclosure();

  return (
    <Box>
      <Button color={'inherit'} startIcon={<InfoPopUpIcon />} onClick={open}>
        แนวทางการเปิดเผย
      </Button>
      <DisclosureGuidelineModal
        open={opened}
        onClose={close}
        title="สภาพการแข่งขันภายในอุตสาหกรรมในปีที่ผ่านมา"
        note={
          <ul style={{ paddingLeft: '16px', listStyleType: 'disc', margin: 0 }}>
            <li style={{ marginBottom: '4px' }}>
              ตัวอักษรปกติ แสดงถึง ข้อกำหนดของแบบ Corporate Value Up
              ตามประกาศคณะกรรมการกำกับตลาดทุนว่าด้วยหลักเกณฑ์ เงื่อนไข
              และวิธีการรายงานการเปิดเผย
              ข้อมูลเกี่ยวกับฐานะการเงินและผลการดำเนินงานของบริษัทที่ออกหลักทรัพย์
            </li>
            <li>
              ตัวอักษรเอียง แสดงถึง คำอธิบาย แนวปฏิบัติ คำแนะนำ
              และตัวอย่างประกอบเพิ่มเติม
              ซึ่งจะมีคำอธิบายเฉพาะหัวข้อที่อาจมีปัญหาในทางปฏิบัติ
              หรืออาจต้องการแนวปฏิบัติหรือคำแนะนำที่ช่วยในการจัดทำแบบ Corporate
              Value up
            </li>
          </ul>
        }
        description={
          <>
            <Typography mt={2} fontWeight={'bold'}>
              ให้อธิบายสภาพการแข่งขันภายในอุตสาหกรรมในปีที่ผ่านมา
              และแนวโน้มภาวะอุตสาหกรรมและสภาพการแข่งขันในอนาคต เช่น
              จำนวนคู่แข่งโดยประมาณ ขนาดของบริษัทเมื่อเทียบกับคู่แข่ง
              สถานภาพและศักยภาพในการแข่งขันของบริษัท ชื่อคู่แข่ง
              (โดยทั่วไปไม่จำเป็นต้องเปิดเผย
              เว้นแต่ในกรณีที่ในอุตสาหกรรมนี้มีคู่แข่งเพียงรายเดียว
              หรือน้อยรายที่เป็นผู้นำตลาด) เป็นต้น
            </Typography>

            <br />
            <Typography sx={{ textDecoration: 'underline' }}>
              คำแนะนำ หรือคำอธิบายเพิ่มเติม
            </Typography>
            <Typography>
              1. นโยบายการแข่งขัน และจำหน่ายผลิตภัณฑ์ของบริษัท ควรอธิบาย
            </Typography>
            <Typography>
              1.1 กลุ่มลูกค้าเป้าหมาย ควรอธิบายตลาดหลัก เช่น
              บริษัทเน้นการแข่งขันในตลาดสินค้าคุณภาพสูง สำหรับลูกค้าระดับบน
              ซึ่งมีคู่แข่งน้อยราย ส่วนใหญ่มาจากต่างประเทศ เป็นต้น
              ในกรณีเป็นผลิตภัณฑ์ที่มีลูกค้าเฉพาะกลุ่ม ควรอธิบายลักษณะลูกค้า
              ความสัมพันธ์ และระยะเวลาที่ติดต่อกับลูกค้าด้วย
            </Typography>
            <Typography>
              ทั้งนี้ ควรเน้นอธิบายลูกค้ารายใหญ่ (เช่น มากกว่าร้อยละ 10
              ของรายได้รวม)
            </Typography>
            <Typography>
              แต่หากสัดส่วนของลูกค้ารายใดมีนัยสำคัญต่อการดำเนินธุรกิจ (เช่น
              มากกว่าร้อยละ 30 ของรายได้รวมดังกล่าว)
            </Typography>
            <Typography>ให้เปิดเผยไว้เป็น ปัจจัยความเสี่ยงด้วย</Typography>
            <Typography>
              1.2
              ในกรณีที่บริษัทแต่งตั้งให้บุคคลใดเป็นผู้จัดจำหน่ายแต่เพียงผู้เดียว
              ให้ระบุไว้ด้วย พร้อมชื่อบุคคลดังกล่าว
              และสาระสำคัญของสัญญาแต่งตั้งด้วย เช่น จำนวนปี การกำหนดผลตอบแทน
              เป็นต้น
            </Typography>
            <Typography>2. ภาวะการตลาดและการแข่งขัน</Typography>
            <Typography>
              2.1 ให้อธิบายในภาพรวมที่จะทำให้ผู้ลงทุนสามารถเข้าใจ
              โดยอาจไม่จำเป็นต้องเปิดเผยข้อมูลในเรื่อง ส่วนแบ่งตลาดของคู่แข่ง
              โอกาสและอุปสรรคในอุตสาหกรรม และปัจจัยแห่งความสำเร็จของ
              ผู้ประกอบธุรกิจในอุตสาหกรรม (key success factor)
              แต่ควรอธิบายภาพกว้างเกี่ยวกับอุปสงค์ อุปทาน การมีสินค้าทดแทน
              ปัจจัยที่กระทบต่ออัตราการเติบโตของอุตสาหกรรม เป็นต้น
              (โดยอาจยกตัวเลขประกอบด้วย ก็ได้ เช่น การบริโภคหรือการส่งออก
              เท่ากับ...............ล้านบาท ในปี
              ...............เพิ่มขึ้นเป็น...............ล้านบาท ในปี
              ...............เป็นต้น)
            </Typography>
            <Typography>
              2.2 ควรอธิบายภาวะการตลาดและการแข่งขันข้างต้นของตลาดย่อย (market
              segment) ที่บริษัทแข่งขันอยู่
              โดยอธิบายลักษณะการแบ่งตลาดย่อยนั้นด้วยก็ได้
            </Typography>
            <Typography>
              2.3 การประมาณจำนวนคู่แข่ง
              หรือการวิเคราะห์เปรียบเทียบความสามารถในการแข่งขันของบริษัท
              ควรเลือกเฉพาะคู่แข่งที่อยู่ในตลาดเดียวกันกับบริษัท
            </Typography>
          </>
        }
      />
    </Box>
  );
};

export default DisclosureGuidelinesIndustryMarketPolicies;
